import { Sum, inl, inr } from "widgets-for-react"

export type Right<a> = { v: { kind: "r", v: a } }
export type Left<a> = { v: { kind: "l", v: a } }

export const isRight = <a>(s: Sum<unknown,a>): s is { v: { kind: "r", v: a } } => s.v.kind === "r"
export const isLeft = <a>(s: Sum<a,unknown>): s is { v: { kind: "l", v: a } } => s.v.kind === "l"

export const mapRight = <a,b>(f: (_:a) => b) => <_>(s: Sum<_,a>): Sum<_,b> => s.v.kind === 'r' ? inr(f(s.v.v)) : inl(s.v.v)
export const mapLeft = <a,b>(f: (_:a) => b) => <_>(s: Sum<a,_>): Sum<b,_> => s.v.kind === 'l' ? inl(f(s.v.v)) : inr(s.v.v)

